import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Video from '@/components/Video'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/video',
      name: 'video',
      component: Video,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js